export default __webpack_public_path__ + "d28a6037812f8b2970a0724d46ba3541.png";